import { render } from "./Form.vue?vue&type=template&id=a1d7aa1a&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=a1d7aa1a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a1d7aa1a"

export default script